import { Box, Grid, Modal } from "@mui/material";
import React from "react";

import CloseIcon from "@mui/icons-material/Close";

const ImagePreviewModal = ({ modalOpen, handleClose, image, imageOP }) => {
  return (
    <Modal open={modalOpen} onClose={handleClose} sx={{zIndex: 3002}}>
      <Box sx={imageModalStyles}>
        <Grid container direction={"column"}>
          <Grid container justifyContent={"flex-end"}>
            <CloseIcon
              onClick={handleClose}
              style={{ cursor: "pointer", marginTop: 10, marginBottom: 10 }}
            />
          </Grid>
          <Grid container>
            <img
              src={image || imageOP}
              alt="table"
              style={{ width: "100%", height: "85vh", objectFit: "contain" }}
            />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default ImagePreviewModal;

const imageModalStyles = {
  position: "absolute",
  top: "2%",
  bottom: "2%",
  left: "15%",
  // transform: "translate(-50%, -50%)",
  width: "70% ",
  // height: "70%",
  bgcolor: "#fff",
  borderRadius: 2,
  p: 2,
};
